// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 937 ? "eabe11fc" : chunkId) + "." + {"167":"dbc3fa1cff8be22f","937":"b60dcff574eeca58"}[chunkId] + ".js";
};